import { defineType } from 'sanity';

export const coreValues = defineType({
    name: 'coreValues',
    title: 'Core values section',
    type: 'object',
    fields: [
        {
            name: 'title',
            title: 'Title',
            type: 'localizedString',
        },
        {
            name: 'description',
            title: 'Description',
            type: 'localizedText',
        },
        {
            name: 'image',
            title: 'Image',
            type: 'seoOptimizedImageUrl',
        },
        {
            name: 'variant',
            title: 'Variant',
            type: 'string',
            options: {
                list: [
                    { title: 'Variant A', value: 'A' },
                    { title: 'Variant B', value: 'B' },
                    { title: 'Variant C', value: 'C' },
                ],
            },
        },
    ],
    // preview: {
    //     select: {
    //         title: 'title',
    //     },
    // },
    preview: {
        select: {
            title: 'title',
        },
        prepare({ title }) {
            return {
                title: `Core values: ${title['en'] || title['sr']}`,
            };
        },
    },
});
